import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IOneHallPayload {
    hallId: string
}

export interface IOneHallState {
    status: string
    data: null
    errors: any
}

const initialState: IOneHallState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const oneHall = createSlice({
    name: 'hall/one-hall',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IOneHallPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const oneHallActions = oneHall.actions
export default oneHall.reducer
